import { render, staticRenderFns } from "./IconCompleted.vue?vue&type=template&id=36f91ba4&scoped=true"
import script from "./IconCompleted.vue?vue&type=script&lang=js"
export * from "./IconCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f91ba4",
  null
  
)

export default component.exports